import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { T } from "@freightsimple/ui-core/Typography/T";
import PageLoadingSpinner from "@/Shared/Components/CustomComponents/PageLoadingSpinner";
import { useOnce } from "@/Hooks/useOnce";
import useQuery from "@/Hooks/useQuery";
import { useState } from "react";
import { useSignInDirectly } from "@/Shared/Authentication/Hooks/useAuthenticationSignIn";

/*
    It's the job of this screen to take login credentials from url parameters, then use them to log in and create a session
*/
export function QuickLoginScreen() {
  const query = useQuery();
  const { signIn, continueAfterReset } = useSignInDirectly();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const email = query["email"];
  const password = query["password"];

  useOnce(async function () {
    if (typeof email !== "string" || typeof password !== "string") {
      setErrorMessage("Missing login credentials");
      return;
    }
    try {
      const { accessToken, expiresAt } = await signIn(email, password);
      continueAfterReset(accessToken, expiresAt);
    } catch (e: unknown) {
      // signIn rejects with the auth0 error description string
      setErrorMessage(typeof e === "string" ? e : String(e));
    }
  });

  if (errorMessage) {
    return (
      <Center>
        <T align="center">
          Unfortunately there was an error logging in : {errorMessage}
        </T>
      </Center>
    );
  } else {
    return <PageLoadingSpinner></PageLoadingSpinner>;
  }
}
